export default __webpack_public_path__ + "static/media/g-ml.859c9885.svg";